const resortOpeningDates = () => `
  openingDates {
    opening
    closing
  }
`;

type AllResortsOptions = {
  withOpeningDates?: boolean;
};
export const getAllResorts = ({ withOpeningDates = false }: AllResortsOptions = {}): string => `
  resortList: resorts(productTypes: [VILLAGE, JOYVIEW, VILLA]) {
    badgeIcon
    color
    comfort
    comfortLabel
    destination {
      area
      country
    }
    hasECSpace
    id
    isExplicitEC
    openingStatus
    isJoyview
    isUrbanOasis
    name
    offsetSell
    seasonTrad
    type
    ${withOpeningDates ? resortOpeningDates() : ''}
  }
`;
